import React, { useEffect } from 'react'
import { BeforeYouLeaveProvider } from '@/contexts/BeforeYouLeaveContext'
import { BeforeYouLeaveModal } from '@/molecules/BeforeYouLeaveModal'
import { IntroMeta, Torch } from '@/services/TorchesService'
import { Project } from '@/types/codegen-federation'
import { ICampaignAssets } from '@/types/generated-contentful'
import { useSafeAnalytics } from '@/utils/analytics'
import { TorchCards } from './TorchCards'
import { TorchesHeroBanner } from './TorchesHeroBanner'
import TorchesJourney from './TorchesJourney'

export interface TorchesViewProps {
  campaignAssets: ICampaignAssets[]
  heroMeta?: IntroMeta
  projectsExpressingInterest: Project[]
  torchesInvesting?: Torch[]
  torchesExpressingInterest?: Torch[]
}

export const TorchesView: React.FC<TorchesViewProps> = ({
  campaignAssets,
  heroMeta,
  projectsExpressingInterest,
  torchesInvesting,
  torchesExpressingInterest,
}) => {
  const { track } = useSafeAnalytics()

  useEffect(() => {
    track('Land on Torches Landing Page')
  }, [track])

  return (
    <BeforeYouLeaveProvider>
      <BeforeYouLeaveModal />
      <div className="mx-auto flex max-w-[1728px] flex-col items-center justify-start gap-4">
        <TorchesHeroBanner heroMeta={heroMeta} />
        <TorchesJourney />
        <TorchCards
          campaignAssets={campaignAssets}
          projectsExpressingInterest={projectsExpressingInterest}
          torchesInvesting={torchesInvesting}
          torchesExpressingInterest={torchesExpressingInterest}
        />
      </div>
    </BeforeYouLeaveProvider>
  )
}
